export default __webpack_public_path__ + "static/media/js.20c1915c.svg";